export function getCurrentUrl(): string {
  return window.location.href;
}
